import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";

//Internal
import { Modal, SelectList } from "../../components-old/ComponentsIndex";
import { px2vw } from "../../utils/device";
import { countryLocaleMapping } from "../../AppConstants";

const SettingsModal = (props) => {
  const [widthFactor, setWidthFactor] = useState(
    props.settings.initialWidth ? props.settings.initialWidth : 100
  );
  const [openModal, setOpenModal] = useState(true);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [availableLocales, setAvailableLocales] = useState([]);

  const handleModalClose = () => {
    setOpenModal(false);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setWidthFactor(500);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
  }, []);

  // Update available locales when selectedCountry changes
  useEffect(() => {
    if (selectedCountry) {
      // Retrieve locales from countryLocaleMapping based on selected country and add "English" option
      const countryLocales = countryLocaleMapping[selectedCountry] || [];
      const englishOption = { key: "en_GB", value: "English" };
      const updatedLocales = [englishOption, ...countryLocales];

      setAvailableLocales(updatedLocales);
    }
  }, [selectedCountry]);

  return (
    <Modal
      title={props.settings.modalTitle ? props.settings.modalTitle : "Settings"}
      imageUrl={props.settings.imageUrl ? props.settings.imageUrl : ""}
      firstActionDesc={
        props.settings.modalFirstAction
          ? props.settings.modalFirstAction
          : "Cancel"
      }
      secondActionDesc={
        props.settings.modalSecondAction
          ? props.settings.modalSecondAction
          : "Confirm"
      }
      status={openModal}
      handleClose={
        props.settings.onModalFirstActionClick
          ? props.settings.onModalFirstActionClick
          : handleModalClose
      }
      onSecondActionClick={
        props.settings.onModalSecondActionClick
          ? props.settings.onModalSecondActionClick
          : () => { }
      }
    >
      <SelectList
        selectMinWidth={px2vw(widthFactor, window.innerWidth)}
        placeholder={props.settings.sourcePlaceholder}
        selectListLabel={props.settings.sourceListLabel}
        item={props.settings.sourceItem}
        onSelection={(event) => {
          setSelectedCountry(event.target.value); // Update the selected country
          props.settings.onBusinessSourceSelection(event); // Invoke callback if provided
        }}
        selectedValue={props.settings.selectedBusinessSourceValue}
      />
      <Box sx={{ m: "40px" }} />
      <SelectList
        selectMinWidth={px2vw(widthFactor, window.innerWidth)}
        placeholder={props.settings.languagePlaceholder || "Select a language"}
        selectListLabel={props.settings.languageListLabel || "Language"}
        item={availableLocales} // Language options update based on selected country
        onSelection={props.settings.onLanguageSelection}
        selectedValue={props.settings.selectedAppLanguage}
      />
    </Modal>
  );
};

export default SettingsModal;
